export const COMPONENT_IDS = {
    HEADER: '$HEADER',
    FOOTER: '$FOOTER',
};

export const NetworkContextName = 'NETWORK';
